import { createClient } from "@supabase/supabase-js"

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://placeholder.supabase.co"
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "placeholder-key"

// Log configuration status for debugging
console.log("[v0] Supabase configuration:", {
  url: supabaseUrl,
  hasKey: !!process.env.REACT_APP_SUPABASE_ANON_KEY,
  isConfigured: !!(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY),
})

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Export a flag to check if Supabase is properly configured
export const isSupabaseConfigured = !!(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY)
